module.exports = __webpack_public_path__ + "static/media/feature-stylish-logo2.dd98f198.png";